module.exports = __webpack_public_path__ + "img/logo-new.62247f3d.png";